import { render, staticRenderFns } from "./LogDetailsTable.vue?vue&type=template&id=73269132&"
import script from "./LogDetailsTable.vue?vue&type=script&lang=js&"
export * from "./LogDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports